import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import styles from './product-tags.module.scss'
import { isReadyToShipTagSupportedForProduct } from './utils'

const ReadyToShip = ({ shopifyProductId }: { shopifyProductId: number }) => {
  const shouldShowReadyToShipTag = isReadyToShipTagSupportedForProduct(shopifyProductId)
  const { t } = useTranslation('common')
  return shouldShowReadyToShipTag ? (
    <li className={classnames(styles.tag)} key="readyToShip">
      {t('ready_to_ship')}
    </li>
  ) : null
}

export { ReadyToShip }
